import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "applicationDetails" }
const _hoisted_2 = { id: "collapseDetails" }

import Loader from "@/components/Loader.vue";
import BreadCrumb from "@/components/application/BreadCrumb.vue";
import Page from "@/components/layout/Page.vue";
import Details from "@/components/v2/application/Details.vue";
import ApplicationApplicantDetails from "@/components/v2/application/ApplicationApplicantDetails.vue";
import TabWrapper from "@/components/wrappers/TabWrapper.vue";
import { onMounted, onUnmounted, ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { useTypeStore } from "@/store/store/typeStore";
import { Type } from "@/types/types";
import { useStipulationStore } from "@/store/store/stipulationStore";
import JumpToMenu from "@/components/navigation/JumpToMenu.vue";
import { JumpToMenuLink } from "@/types/jumpto-menu";
import functions from "@/use/functions";


export default /*@__PURE__*/_defineComponent({
  __name: 'Application',
  setup(__props) {

const route = useRoute();
const applicationStore = useApplicationStore();
const typeStore = useTypeStore();
const stipulationStore = useStipulationStore();
const isReady = ref(false);

const menuItems = computed<JumpToMenuLink[] | undefined>(
  () => applicationStore?.application?.detailViewModel?.jumpToMenuLinks
);
const showJumpToMenu = computed<boolean>(
  () => applicationStore?.application?.detailViewModel?.showJumpToMenu || false
);
const showMovedToLoanServiceBanner = computed<boolean>(
  () =>
    applicationStore?.application?.detailViewModel
      ?.showMovedToLoanServiceBanner || false
);

async function initializeApplication() {
	const referenceId = route.params.referenceId.toString();

  await Promise.all([
    applicationStore.getApplication(referenceId),
    applicationStore.getApplicationSummary(referenceId),
    applicationStore.getTabTags(referenceId),
    typeStore.getType(Type.JudgmentDenials),
    typeStore.getType(Type.ApplicationStatusReasons),
    typeStore.getDocServiceType(),
  ]);

  document.title = `${applicationStore.ApplicantSelected.lastName || ""},
		${applicationStore.ApplicantSelected.firstName || ""}.
		(${
      applicationStore.viewModel.referenceId?.trim() || ""
    }) - Loan Origination System`;

  isReady.value = true;
	const defaultTab = "ApplicationTab";
	
  let currentTab = localStorage.getItem(`${applicationStore.pageIdentifier}.currentTab`) || defaultTab;
  applicationStore.updateActiveTab(currentTab);

	functions.logPageView({
    id: referenceId,
    page: "applications",
    category: "Application",
    timestamp: Date.now(),
    firstName: applicationStore.application?.tabApplicationViewModel.primaryApplicant?.firstName,
    lastName: applicationStore.application?.tabApplicationViewModel.primaryApplicant?.lastName,
    name: applicationStore.application?.tabApplicationViewModel.primaryApplicant?.fullName,
    lenderId: applicationStore.application?.detailViewModel.lenderId,
		lenderName: applicationStore.application?.detailViewModel.lenderName
  });
}

onMounted(async () => {
	await initializeApplication();
});

onUnmounted(() => {
  applicationStore.$reset();
  stipulationStore.$reset();

  localStorage.removeItem("cache.selected");
  localStorage.removeItem(`${applicationStore.pageIdentifier}.currentTab`);
});

watch(
	() => route.params.referenceId,
	async (newReferenceId, oldReferenceId) => {
		if (newReferenceId !== oldReferenceId) {
			isReady.value = false;
			
			await initializeApplication();

			isReady.value = true;
		}
	}
);

return (_ctx: any,_cache: any) => {
  return (isReady.value)
    ? (_openBlock(), _createBlock(Page, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(BreadCrumb, null, _createSlots({ _: 2 }, [
            (showMovedToLoanServiceBanner.value)
              ? {
                  name: "loanservice-banner",
                  fn: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon-circle-check loanservice-banner" }, " This application has been completed and moved to Loan Service. ", -1))
                  ]),
                  key: "0"
                }
              : undefined,
            (showJumpToMenu.value)
              ? {
                  name: "jumpto",
                  fn: _withCtx(() => [
                    _createVNode(JumpToMenu, { menuItems: menuItems.value }, null, 8, ["menuItems"])
                  ]),
                  key: "1"
                }
              : undefined
          ]), 1024),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(Details)
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(ApplicationApplicantDetails)
            ]),
            _createVNode(TabWrapper)
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(Loader, { key: 1 }))
}
}

})